import { PriorityEnum } from '@application/enums/priority-enum';
import { TaskCompletionStatusEnum } from '@application/enums/task-completion-status-enum';
import { alpha, useTheme } from '@mui/material';
const normalizePriority = (priority) => {
    if (typeof priority === 'number' && priority in PriorityEnum) {
        return priority;
    }
    if (typeof priority === 'string') {
        switch (priority.toLowerCase()) {
            case 'high':
                return PriorityEnum.High;
            case 'medium':
                return PriorityEnum.Medium;
            case 'low':
                return PriorityEnum.Low;
            case 'none':
                return PriorityEnum.None;
            default:
                return PriorityEnum.Medium;
        }
    }
    return PriorityEnum.Medium;
};
const useActivityTaskCardStyles = (priority = PriorityEnum.Low, status = TaskCompletionStatusEnum.New) => {
    const theme = useTheme();
    const resolvedPriority = normalizePriority(priority);
    const resolvedStatus = typeof status === 'string'
        ? TaskCompletionStatusEnum[status] ??
            TaskCompletionStatusEnum.New
        : status;
    const priorityChipColors = {
        [PriorityEnum.Low]: {
            backgroundColor: alpha(theme.palette.grey[500], 0.08),
            color: theme.palette.text.primary
        },
        [PriorityEnum.Medium]: {
            backgroundColor: alpha(theme.palette.warning.main, 0.16),
            color: theme.palette.warning.dark
        },
        [PriorityEnum.High]: {
            backgroundColor: alpha(theme.palette.success.main, 0.16),
            color: theme.palette.success.dark
        },
        [PriorityEnum.None]: {
            backgroundColor: theme.palette.grey[200],
            color: theme.palette.grey[800]
        }
    };
    return {
        taskCard: {
            borderRadius: (theme) => theme.spacing(3),
            py: (theme) => theme.spacing(2),
            px: (theme) => theme.spacing(2),
            backgroundColor: (theme) => theme.palette.background.paper,
            border: (theme) => `1px solid ${alpha(theme.palette.grey[500], 0.24)}`,
            width: '100%',
            position: 'relative',
            transition: 'all 0.3s ease-in-out'
        },
        boxTop: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        boxBottom: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            mt: 1
        },
        boxItem: {
            display: 'flex',
            gap: 0.5,
            alignItems: 'center'
        },
        assignedToDropdown: {
            mt: '7px',
            mb: '5px',
            flex: 1,
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            backgroundColor: (theme) => theme.palette.common.grey8,
            color: (theme) => theme.palette.grey[900],
            textTransform: 'none'
        },
        assignToDropdown: {
            mt: '7px',
            flex: 1,
            width: '100%',
            border: `1px solid ${alpha(theme.palette.grey[500], 0.32)} `,
            background: 'transparent',
            color: (theme) => theme.palette.primary.darker,
            borderColor: (theme) => theme.palette.primary.darker
        },
        taskHeading: {
            textDecorationLine: resolvedStatus === TaskCompletionStatusEnum.Completed ? 'line-through' : 'none',
            width: 'calc(100% - 40px)',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden'
        },
        priorityChip: {
            backgroundColor: priorityChipColors[resolvedPriority].backgroundColor,
            color: priorityChipColors[resolvedPriority].color,
            fontSize: '12px',
            fontWeight: 500
        },
        bottomNewTaskDrawer: {
            p: 2,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16
        }
    };
};
export default useActivityTaskCardStyles;
